var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_771_1",
    "data-name": "Component 771 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 20,
    height: 20,
    fill: "#176bfb",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5970",
    "data-name": "Path 5970",
    d: "M9.672,16.889C3.6,16.889.22,10.277.079,9.995a.751.751,0,0,1,.01-.69A15.586,15.586,0,0,1,4.4,4.253a.75.75,0,0,1,.91,1.192,14.076,14.076,0,0,0-3.7,4.216c.739,1.276,3.635,5.728,8.053,5.728a7.437,7.437,0,0,0,4.356-1.515.75.75,0,1,1,.91,1.193,8.962,8.962,0,0,1-5.254,1.822m7.149-3.895a.75.75,0,0,1-.574-1.233,14.3,14.3,0,0,0,1.467-2.1C16.976,8.384,14.079,3.93,9.66,3.93H9.649a6.683,6.683,0,0,0-1.518.175.75.75,0,0,1-.342-1.461A8.208,8.208,0,0,1,9.648,2.43h.013c6.063,0,9.44,6.613,9.58,6.895a.749.749,0,0,1-.009.689,15.741,15.741,0,0,1-1.838,2.713.749.749,0,0,1-.573.267m-7.229-.085a3.179,3.179,0,0,1-2.33-5.341c.054-.058.113-.118.176-.175A.749.749,0,1,1,8.449,8.5c-.029.028-.057.056-.084.085a1.68,1.68,0,1,0,2.461,2.287.75.75,0,0,1,1.1,1.017,3.15,3.15,0,0,1-2.21,1.019l-.126,0",
    transform: "translate(0.34 0.341)",
    fill: "#213960"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5971",
    "data-name": "Path 5971",
    d: "M18.57,19.319a.744.744,0,0,1-.53-.22L.22,1.28A.75.75,0,0,1,1.281.219L19.1,18.039a.75.75,0,0,1-.53,1.28",
    transform: "translate(0.34 0.341)",
    fill: "#213960"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.11b1de98ba6885a16403f5dd79ee2b13.svg";
export { ForwardRef as ReactComponent };